module.exports = __webpack_public_path__ + "img/error-404.a2792e62.svg";